export default {
  ErrorMessage: {
    NetworkError: 'Lỗi mạng. Vui lòng kiểm tra lại kết nối internet.',
    BadRequest: 'Yêu cầu không hợp lệ. Vui lòng kiểm tra lại',
    Unauthorized: 'Không thể xác thực người dùng. Vui lòng đăng nhập.',
    InternalServerError: 'Đã có lỗi xảy ra.',
    NotFound: 'Không tìm thấy trang',
    UnallowRole: 'Bạn không có quyền thực hiện tính năng này.'
  }
}
